import React from 'react';
import { grid } from '@noths/polaris-client-ribbons-base';

import * as styles from './ProductCarouselSkeleton.styles';
import { SkeletonCard } from 'client-ribbons-design-system/components/elements/Loaders/Skeletons/components/SkeletonCard';
import { SkeletonLabel } from 'client-ribbons-design-system/components/elements/Loaders/Skeletons/components/SkeletonLabel';
import * as imageStyles from 'client-ribbons-design-system/styles/image';

export interface ProductCarouselSkeletonProps {
  numberOfItems?: number;
}

export const ProductCarouselSkeleton = ({ numberOfItems = 6 }: ProductCarouselSkeletonProps) => (
  <>
    <header css={[styles.header]}>
      <SkeletonLabel css={imageStyles.imageWidth.regular} labelHeight="MD" />
    </header>
    <div css={[grid, styles.carousel]}>
      {Array.from({ length: numberOfItems }).map((_, key) => (
        <div css={imageStyles.imageWidth.regular} key={key}>
          <SkeletonCard cropImageForMobile={false} />
        </div>
      ))}
    </div>
  </>
);
